import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { StockConfigurationType } from 'app/typings/core/common/openingConfiguration/stockConfigurationType';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as HOTEL_QUERY_KEYS } from '../hotel/index';

import { ENDPOINTS } from '.';

export type PayloadProps = {
  categoryId: number;
  openingConfiguration?: { stockConfiguration: StockConfigurationType };
  time?: string;
  closedDays?: number | null;
  maxQuantity?: number;
};

export function useExperienceAddOn(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PayloadProps) =>
      apiMutation(
        'POST',
        {
          path: ENDPOINTS.saveExperienceAddOn,
          params: { id: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [HOTEL_QUERY_KEYS.hotelExperiences],
      });
    },
    onError: (err) => {
      message.error('Error while saving experience add on');
    },
  });
}
